/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interest_CryptoInputs */

const en_onboarding_v1_interest_crypto = /** @type {(inputs: Onboarding_V1_Interest_CryptoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crypto`)
};

const de_onboarding_v1_interest_crypto = /** @type {(inputs: Onboarding_V1_Interest_CryptoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krypto`)
};

const pt_br2_onboarding_v1_interest_crypto = /** @type {(inputs: Onboarding_V1_Interest_CryptoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cripto`)
};

const tr_onboarding_v1_interest_crypto = /** @type {(inputs: Onboarding_V1_Interest_CryptoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kripto`)
};

const zh_cn2_onboarding_v1_interest_crypto = /** @type {(inputs: Onboarding_V1_Interest_CryptoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加密资产`)
};

const zh_hk2_onboarding_v1_interest_crypto = /** @type {(inputs: Onboarding_V1_Interest_CryptoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加密資產`)
};

const ko_kr2_onboarding_v1_interest_crypto = /** @type {(inputs: Onboarding_V1_Interest_CryptoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가상자산`)
};

const ru_ru2_onboarding_v1_interest_crypto = /** @type {(inputs: Onboarding_V1_Interest_CryptoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Криптоактивы`)
};

const es_419_onboarding_v1_interest_crypto = /** @type {(inputs: Onboarding_V1_Interest_CryptoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cripto`)
};

/**
* | output |
* | --- |
* | "Crypto" |
*
* @param {Onboarding_V1_Interest_CryptoInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interest_crypto = /** @type {((inputs?: Onboarding_V1_Interest_CryptoInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interest_CryptoInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interest_crypto(inputs)
	if (locale === "de") return de_onboarding_v1_interest_crypto(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interest_crypto(inputs)
	if (locale === "tr") return tr_onboarding_v1_interest_crypto(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interest_crypto(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interest_crypto(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interest_crypto(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interest_crypto(inputs)
	return es_419_onboarding_v1_interest_crypto(inputs)
});